export default "__VITE_ASSET__C51SCH9Z__"